const config = require("config");

(function () {
  angular
    .module("app")
    .factory("customPlaceSetService", [
      "$http",
      "$q",
      "favoriteLocationsService",
      "LocationItem",
      "_",
      function (
        $http,
        $q,
        favoriteLocationsService,
        LocationItem,
        _
      ) {

        // pchen: promise that resolves to
        //   [ <DASet where Places: [ LocationItem instead of DAPlace ]> ]
        // unresolved promise means existing webservice call in-progress, in which case new calls should NOT be started
        let lazyInitdCustomPlaceSets;
        // used to check whether the data is ready for favorite name validation
        let inProgress = false;

        function loadCustomPlaceData() {
          inProgress = true;
          lazyInitdCustomPlaceSets = $q.all([
            // TODO pchen: have an endpoint specifically to get this data in one call, instead of having two calls
            getDAPlaceSetsWithPlaces({onlyMine: true, useShared: false}),
            getDAPlaceSetsWithPlaces({onlyMine: true, useShared: true})
          ])
            .then(([ownerSets, accountSets]) => {
              return ownerSets.concat(accountSets);
            })
            .then(daPlaceSets => {
              // filter out favorites; they are managed by a different service
              daPlaceSets = favoriteLocationsService.filterOutFavoriteSets(daPlaceSets);
              daPlaceSets
                .forEach(daPlaceSet => {
                  daPlaceSet.Places = daPlaceSet.Places.map(daPlace => {
                    return new LocationItem(daPlace, daPlace.PlaceName)
                  });
                });
              return daPlaceSets;
            })
            .catch(err => {
              // pchen: reset state; no longer "in progress"
              // TODO pchen: expose the errors to the user
              lazyInitdCustomPlaceSets = undefined;
            })
            .finally(() => {
              inProgress = false;
            });

          return lazyInitdCustomPlaceSets;
        }

        function isDataLoaded() {
          return (lazyInitdCustomPlaceSets !== undefined) && !inProgress;
        }

        function getDAPlaceSetsWithPlaces({onlyMine = true, useShared = false} = {}) {
          const params = {
            "includePlaces": true,
            onlyMine,
            useShared,
            "readOnlyPublicData": false
          };

          const request = {
            method: "GET",
            url: `${config.daUrl}place-sets/-1`,
            params
          };

          return $http(request)
            .then(({data: placeSetList}) => {
              return placeSetList;
            });
        }

        function getCustomPlaceSets() {
          if (lazyInitdCustomPlaceSets === undefined) {
            loadCustomPlaceData();
          }
          return lazyInitdCustomPlaceSets;
        }

        return {
          getCustomPlaceSets,
          isDataLoaded
        }
      }
    ]);
})();



// WEBPACK FOOTER //
// ./app/places/customPlaceSet.service.js